<template>
    <div>
        <Topnav />
        <v-row>
            <v-col
                v-if="leftNavbar"
                cols="12"
                md="2"
            >
                <Leftnav />
            </v-col>
            <v-col
                class="container-fluid pr-12"
                cols="12"
                md
            >
                <v-card
                    class="pa-3"
                    elevation="6"
                >
                    <div class="btn-box">
                        <v-card
                            elevation="2"
                            class="card-msg-style"
                            outlined
                            shaped
                            v-for="(item , index) in list"
                            :key = "index"
                        >
                            <h2 class="title-msg">{{item.title}}</h2>
                            <p class="contact-msg">{{item.number}}<br>{{item.time}}</p>
                            <span>{{item.message}}</span>
                            <br>
                            <div class="msg-btn">
                                <v-btn
                                    depressed
                                    color="error"
                                    elevation="2"
                                    @click="deleteMsg(item._id)"
                                >
                                删除
                                </v-btn>
                            </div>
                        </v-card>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import Topnav from '@/components/TopNavbar.vue'
import Leftnav from '@/components/LeftNavbar.vue'
import Common from '@/components/common.vue'
export default {
    name : 'News',
    components: {
        Topnav,
        Leftnav
    },
    data(){
        return {
            detailIndex : Common.baseURL + 'message/index',
            delete : Common.baseURL + 'message/delete',
            leftNavbar: true,
            list:'',
        }
    },
    mounted(){

    },
    created(){
        this.messageList()
    },
    watch:{

    },
    methods:{
        messageList(){
            this.axios({
                method: 'post',
                url: this.detailIndex,
            }).then( data => {
                console.log(data)
                this.list = data.data.data.reverse()
            })
        },


        deleteMsg(id){
            this.axios({
                method: 'post',
                url: this.delete,
                data : {
                    _id : id
                }
            }).then( data => {
                console.log(data)
                location. reload()
            })
        }
    }
}
</script>
<style scoped>
.card-msg-style{
    padding: 20px;
    margin: 20px;
    box-sizing: border-box;
}
.title-msg{
    line-height: 48px;
}
.contact-msg{
    margin-bottom: 18px;
}
.msg-btn{
    margin-top: 20px;
}
</style>